import React from 'react';
import PropTypes from 'prop-types';
import {I18nMessage} from '../../contexts/I18n';


function JnexId({id, useShortLabel}) {

    return (
        <>
            <I18nMessage id={`journexx.id.${useShortLabel ? 'short' : 'regular'}`}/>: {id}
        </>
    );
}


JnexId.propTypes = {
    id: PropTypes.string.isRequired,
    useShortLabel: PropTypes.bool.isRequired
};

JnexId.defaultProps = {
    useShortLabel: false
};


export default JnexId;
